// components without MediaContainer

import { BoelsCmsLinkComponent, CmsComponent } from './cms.model';
import { BackgroundColorEnum } from './boels-background-color.model';
import { Image } from './image.model';
import { MediaContainer } from './media.model';

export interface BoelsBannerTeaser extends CmsComponent {
  title?: string;
  image?: Image;
  link?: BoelsCmsLinkComponent;
  imageAltText?: string;
  subtitle?: string;
  removeGradient?: boolean;
  alignment?: AlignmentEnum;
}

export interface ImageText extends BoelsBannerTeaser {
  imageAlignment?: AlignmentEnum;
  backgroundColor?: BackgroundColorEnum;
  bodyText?: string;
  removeBottomSpacing?: boolean;
}

export interface SmallBannersComponentData extends CmsComponent {
  leftBanner?: BoelsBannerTeaser;
  rightBanner?: BoelsBannerTeaser;
  removeBottomSpacing?: boolean;
}

export interface SplitBannerComponentData extends BoelsBannerTeaser {
  removeBottomSpacing?: boolean;
}

export interface BoelsBannerMediaTeaser extends CmsComponent {
  media?: MediaContainer;
  title?: string;
  link?: BoelsCmsLinkComponent;
  imageAltText?: string;
  subtitle?: string;
  removeBottomSpacing?: boolean;
}

export interface ContentHeaderComponentData extends BoelsBannerMediaTeaser {
  pageType: string;
}

export interface FullWidthBannerComponentData extends BoelsBannerMediaTeaser {
  alignment?: AlignmentEnum;
  removeGradient?: boolean;
}

export interface HomepageHero extends FullWidthBannerComponentData {
  altText?: string;
}

export enum AlignmentEnum {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
}

export enum BannerTypeEnum {
  SPLIT = 'banner--split',
  FULLWIDTH = 'banner--fullwidth',
  SMALL = 'banner--small banner--fullwidth',
}
